module.exports = __webpack_public_path__ + "static/img/dorset.cd75baa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/dorset.jpg
// module id = HlYY
// module chunks = 1